import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;
    background-color: #f3f4f6;
    color: #101828;
    font-size: 13px;
  }

  body, html {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    min-height: 100dvh;
  }

  #root, #root > div {
    height: 100%;
  }

  .App {
    display: flex;
    height: 100vh;
  }

  .main-content {
    display: flex;
    flex: 1;
  }

  .content {
    flex: 1;
    padding: 0px;
  }

  * {
    box-sizing: border-box;
  }

  a:focus-visible,
  button:focus-visible,
  [role='button']:focus-visible,
  [tabindex]:not([tabindex='-1']):focus-visible {
    outline: 2px solid #f97316;
    outline-offset: 2px;
  }

  .skip-to-content {
    background: #ffffff;
    border: 2px solid #f97316;
    border-radius: 7px;
    color: #101828;
    font-weight: 600;
    left: 10px;
    padding: 8px 12px;
    position: fixed;
    top: 8px;
    transform: translateY(-150%);
    transition: transform 120ms ease;
    z-index: 2000;
  }

  .skip-to-content:focus {
    transform: translateY(0);
  }

  ::selection {
    background: #fed7aa;
    color: #111827;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f3f4f6;
  }

  ::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 999px;
    border: 2px solid #f3f4f6;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }

  .ant-layout {
    background: #f3f4f6;
  }

  .ant-layout-content > div {
    box-shadow: none;
  }

  .ant-card {
    border-color: #e5e7eb;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);
  }

  .ant-card-head {
    min-height: 38px;
    padding: 0 10px;
    border-bottom-color: #eef0f3;
  }

  .ant-card-head-title {
    padding: 8px 0;
    color: #101828;
    font-size: 14px;
    font-weight: 600;
  }

  .ant-card-body {
    padding: 12px;
  }

  .ant-card-body > *:first-child {
    margin-top: 0;
  }

  .ant-card-body > *:last-child {
    margin-bottom: 0;
  }

  .ant-typography,
  h1.ant-typography,
  h2.ant-typography,
  h3.ant-typography,
  h4.ant-typography,
  h5.ant-typography {
    color: #101828;
  }

  h1, h2, h3, h4, h5 {
    letter-spacing: 0;
  }

  .ant-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    box-shadow: none;
  }

  .ant-btn-primary {
    background: #f97316;
    border-color: #f97316;
  }

  .ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover {
    background: #ea580c;
    border-color: #ea580c;
  }

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select-selector,
  .ant-picker,
  .ant-input-number {
    border-color: #d0d5dd;
  }

  .ant-input:hover,
  .ant-input-affix-wrapper:hover,
  .ant-select-selector:hover,
  .ant-picker:hover,
  .ant-input-number:hover {
    border-color: #f97316 !important;
  }

  .ant-input:focus,
  .ant-input-affix-wrapper-focused,
  .ant-select-focused .ant-select-selector,
  .ant-picker-focused,
  .ant-input-number-focused {
    border-color: #f97316 !important;
    box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.14) !important;
  }

  .ant-form-item-label > label {
    color: #344054;
    font-size: 12px;
    font-weight: 500;
  }

  .ant-modal-content {
    padding: 0 !important;
    overflow: hidden;
    box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18);
  }

  .ant-modal-header {
    margin: 0 !important;
    padding: 16px 48px 12px 20px !important;
    border-bottom: 1px solid #eef0f3;
    min-height: 49px;
    display: flex;
    align-items: center;
  }

  .ant-modal-title {
    display: block;
    width: 100%;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
    color: #101828;
    overflow-wrap: anywhere;
  }

  .ant-modal-body {
    padding: 18px 20px !important;
  }

  .ant-modal-footer {
    margin: 0 !important;
    padding: 12px 20px 18px !important;
    border-top: 1px solid #eef0f3;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }

  .ant-modal-footer .ant-btn + .ant-btn {
    margin-inline-start: 0 !important;
  }

  .ant-modal-close {
    top: 11px !important;
    inset-inline-end: 14px !important;
    width: 30px;
    height: 30px;
    border-radius: 7px;
  }

  .ant-modal-close:hover {
    background: #f3f4f6;
  }

  .ant-modal-body > *:first-child {
    margin-top: 0;
  }

  .ant-modal-body > *:last-child {
    margin-bottom: 0;
  }

  .ant-modal-body .ant-form:last-child,
  .ant-modal-body .ant-table-wrapper:last-child,
  .ant-modal-body .ant-descriptions:last-child {
    margin-bottom: 0;
  }

  .ant-table-wrapper {
    color: #101828;
  }

  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-thead > tr > th {
    background: #f8fafc !important;
    color: #344054;
    font-size: 12px;
    font-weight: 600;
    border-bottom-color: #e5e7eb !important;
  }

  .ant-table-tbody > tr > td {
    border-bottom-color: #eef0f3;
    color: #1f2937;
  }

  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: #fff7ed !important;
  }

  .ant-table-cell-fix-left,
  .ant-table-cell-fix-right {
    background: #ffffff;
  }

  .ant-table-thead .ant-table-cell-fix-left,
  .ant-table-thead .ant-table-cell-fix-right {
    background: #f8fafc !important;
  }

  .ant-table-cell-fix-right-first {
    border-inline-start: 1px solid #e5e7eb;
    box-shadow: -7px 0 12px -10px rgba(15, 23, 42, 0.55);
  }

  .ant-pagination {
    margin: 8px 0 0 !important;
  }

  .ant-dropdown .ant-dropdown-menu,
  .ant-select-dropdown,
  .ant-picker-dropdown .ant-picker-panel-container,
  .ant-popover-inner {
    border: 1px solid #eef0f3;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  }

  .ant-tabs-nav {
    margin-bottom: 8px !important;
  }

  .ant-tabs-tab {
    padding: 7px 0;
  }

  .ant-upload-wrapper .ant-upload-drag {
    border-color: #e5e7eb;
    border-radius: 8px;
    background: #f8fafc;
  }

  .ant-upload-wrapper .ant-upload-drag:hover {
    border-color: #f97316;
  }

  .ant-descriptions-bordered .ant-descriptions-item-label {
    background: #f8fafc;
    color: #344054;
    font-weight: 600;
  }

  .ant-descriptions .ant-descriptions-item-content {
    color: #1f2937;
  }

  .ant-empty {
    margin: 10px 0;
  }

  .ant-table-filter-dropdown {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-filter-dropdown .ant-checkbox-group {
    color: #344054;
  }

  .ant-table-filter-dropdown-btns {
    padding: 6px 8px;
    border-top-color: #eef0f3;
  }

  .exposition-mobile-hint {
    display: none;
  }

  @media (max-width: 768px) {
    body {
      font-size: 14px;
      overscroll-behavior-y: contain;
    }

    .ant-card-body {
      padding: 10px;
    }

    .ant-card-head-wrapper {
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 6px 10px;
    }

    .ant-card-head-title {
      min-width: 0;
      overflow-wrap: anywhere;
      white-space: normal;
    }

    .ant-card-extra {
      margin-inline-start: 0;
      max-width: 100%;
    }

    .ant-btn:not(.ant-btn-link),
    .ant-input,
    .ant-input-affix-wrapper,
    .ant-input-number,
    .ant-picker,
    .ant-select-single .ant-select-selector {
      min-height: 40px;
    }

    .ant-btn-icon-only:not(.ant-btn-sm) {
      min-width: 44px;
      min-height: 44px;
    }

    .ant-tabs-nav {
      margin-bottom: 8px;
    }

    .ant-tabs-nav-wrap {
      overflow-x: auto;
      scrollbar-width: none;
    }

    .ant-tabs-nav-wrap::-webkit-scrollbar {
      display: none;
    }

    .ant-tabs-tab {
      min-height: 42px;
      white-space: nowrap;
    }

    .ant-modal-root .ant-modal-wrap {
      overflow: hidden;
    }

    .ant-modal-root .ant-modal:not(.ant-modal-confirm) {
      height: 100dvh;
      margin: 0;
      max-width: none;
      padding-bottom: 0;
      top: 0;
      width: 100vw !important;
    }

    .ant-modal-root .ant-modal:not(.ant-modal-confirm) .ant-modal-content {
      border-radius: 0;
      display: flex;
      flex-direction: column;
      height: 100dvh;
    }

    .ant-modal-root .ant-modal:not(.ant-modal-confirm) .ant-modal-body {
      flex: 1 1 auto;
      max-height: none !important;
      overflow: auto;
      overscroll-behavior: contain;
      padding: 12px !important;
    }

    .ant-modal-root .ant-modal:not(.ant-modal-confirm) .ant-modal-footer {
      flex: 0 0 auto;
      padding-bottom: calc(12px + env(safe-area-inset-bottom)) !important;
    }

    .ant-drawer-content-wrapper {
      max-width: 100vw !important;
      width: 100vw !important;
    }

    .ant-table-filter-dropdown {
      max-width: calc(100vw - 16px);
    }

    .ant-table-filter-dropdown > div {
      max-width: calc(100vw - 16px);
      min-width: 0 !important;
      width: min(320px, calc(100vw - 16px)) !important;
    }

    .ant-pagination {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      justify-content: flex-start;
    }

    .ant-pagination-options-size-changer {
      display: none;
    }

    .qf-mobile-table-view {
      min-width: 0;
      width: 100%;
    }

    .qf-mobile-table-toolbar {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 6px;
    }

    .qf-mobile-table-list {
      display: grid;
      gap: 7px;
    }

    .qf-mobile-table-card {
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
      padding: 9px 10px;
      position: relative;
      text-align: left;
    }

    .qf-mobile-table-card:active {
      background: #fff7ed;
    }

    .qf-mobile-table-selection {
      position: absolute;
      right: 8px;
      top: 8px;
      z-index: 1;
    }

    .qf-mobile-table-selection + .qf-mobile-table-fields {
      padding-right: 30px;
    }

    .qf-mobile-table-fields {
      display: grid;
      gap: 5px;
    }

    .qf-mobile-table-field {
      align-items: start;
      display: grid;
      gap: 8px;
      grid-template-columns: minmax(82px, 32%) minmax(0, 1fr);
    }

    .qf-mobile-table-label {
      color: #667085;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.35;
    }

    .qf-mobile-table-value {
      color: #101828;
      min-width: 0;
      overflow-wrap: anywhere;
    }

    .qf-mobile-table-actions {
      align-items: center;
      border-top: 1px solid #eef0f3;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      justify-content: flex-end;
      margin-top: 8px;
      padding-top: 7px;
    }

    .qf-mobile-table-actions .ant-btn {
      min-height: 40px;
      min-width: 40px;
    }

    .qf-mobile-table-view > .ant-pagination {
      margin: 8px 0 0;
    }

    .orders-form-scroll {
      max-height: calc(100dvh - 150px) !important;
      padding: 0 !important;
    }

    .orders-form-actions {
      background: #fff;
      border-top: 1px solid #eef0f3;
      bottom: 0;
      display: flex;
      padding: 8px 0 calc(4px + env(safe-area-inset-bottom));
      position: sticky;
      width: 100%;
      z-index: 5;
    }

    .orders-form-actions .ant-btn {
      flex: 1 1 auto;
    }

    .qf-nexo-date-popup {
      left: 8px !important;
      max-width: calc(100vw - 16px);
      right: 8px !important;
    }

    .qf-nexo-date-popup .ant-picker-panel-container,
    .qf-nexo-date-popup .ant-picker-panel-layout {
      max-width: 100%;
    }

    .qf-nexo-date-popup .ant-picker-panel-layout {
      flex-direction: column;
    }

    .qf-nexo-date-popup .ant-picker-presets {
      border-bottom: 1px solid #eef0f3;
      border-inline-end: 0;
      max-width: none;
      min-width: 0;
      overflow-x: auto;
      width: 100%;
    }

    .qf-nexo-date-popup .ant-picker-presets ul {
      display: flex;
      gap: 4px;
      padding: 6px;
      width: max-content;
    }

    .qf-nexo-date-popup .ant-picker-presets li {
      background: #f8fafc;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      margin: 0;
      min-height: 38px;
      padding: 8px 10px;
      white-space: nowrap;
    }

    .qf-nexo-date-popup .ant-picker-panels {
      max-width: 100%;
    }

    .qf-nexo-date-popup .ant-picker-panels > :nth-child(n + 2) {
      display: none;
    }

    .exposition-layout-workspace {
      grid-template-columns: minmax(0, 1fr) !important;
    }

    .exposition-pattern-toolbox {
      grid-row: 1;
      position: static !important;
      width: 100%;
    }

    .exposition-layout-workspace > div:first-child {
      grid-row: 2;
    }

    .exposition-mobile-hint {
      background: #eff6ff;
      border: 1px solid #bfdbfe;
      border-radius: 7px;
      color: #344054;
      display: block;
      font-size: 12px;
      margin-bottom: 7px;
      padding: 7px 9px;
      text-align: left;
    }

    .exposition-board-toolbar .ant-input-search {
      flex: 1 1 100%;
      width: 100% !important;
    }

    .quickfox-exposition-board-viewport {
      height: min(58dvh, 520px) !important;
    }

    .ant-modal-header {
      padding: 14px 42px 10px 14px !important;
    }

    .ant-modal-body {
      padding: 14px !important;
    }

    .ant-modal-footer {
      padding: 10px 14px 14px !important;
      gap: 6px;
    }
  }
`;

export default GlobalStyles;
